import { CreateCredentialProps } from '@commenda/types/src/credential/types';
import { fetcher } from '@commenda/utils';

export async function createCredential(body: CreateCredentialProps) {
  const response = await fetcher('credentials', {
    method: 'POST',
    body,
  });

  return response;
}
